import 'zone.js';
import 'hammerjs';
import 'es-module-shims';